module.exports = __webpack_public_path__ + "static/media/loadernew.92eccae5.gif";